<template>
    <section  v-if="hasPermissions(['Building-Room-Type Read', 'Building-Room-Type Write', 'Building-Room-Type Room-Type-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Room types with the associated tasks.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="room_types.length && hasPermissions(['Building-Room-Type Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'room_types_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Building-Room-Type Room-Type-Upload'])"
                />
                <UploadOptions
                    :ref="'file_excel_tasks'"
                    id="file_excel_tasks"
                    :btn_label="'Tasks Upload options'"
                    :empty_format_data="task_empty_format_data"
                    :excel_file_headers="excel_file_task_headers"
                    :file_name="'room_type_tasks_template_file'"
                    @data="uploadTasks($event)"
                    v-if="hasPermissions(['Building-Room-Type Room-Type-Tasks-Upload'])"
                />
                <button v-if="hasPermissions(['Building-Room-Type Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Building-Room-Type Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="room_types.length && hasPermissions(['Building-Room-Type Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="room_types"
                                :search="search"
                                :checkable="true"
                                :historiable="true"
                                @history="history($event)"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                @emitAction="emitAction($event)"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />
        <DeleteValidationsModal
            :breadcrumb="breadcrumb"
            :validate_data="validate_data"
        />


        <FormModal 
            :title="'New Room type'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :tasks="tasks"
            :policings="policings"
            @unshiftObject="unshift_object($event)"
            @cleanUp="clean_up(true)"
        />

        <UpdateModal 
            :title="'Room type Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :tasks="tasks"
            :policings="policings"
            @spliceObject="splice_object($event)"
            ref="update_modal"
        />

        <HistoryModal
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
            :change_type="true"
            :link_event="true"
            :link_message="`<a href='#'>View Tasks movement history</a>`"
            @linkEventReceiver="linkEmitReceptor()"
        />

        <HistoryMovementModal
            ref="history_movement_modal"
            :notyf="notyf"
            :link_message="`<a href='#'>Back to History</a>`"
            :rest_api="rest_api"
            :history_item="history_item"
            :breadcrumb="breadcrumb"
            :link_event="true"
            @linkEventReceiver="linkEmitEmisor()"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers_summary"
            :excel_data="excel_data"
            :file_name="failed_file_excel_name"
        />

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import HelperModal              from    '@/components/HelperModal'
import Resources                from    './resources'
import FormModal                from    './FormModal'
import UpdateModal              from    './UpdateModal'
import DinamicTable             from    '@/components/DinamicTable'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import DeleteValidationsModal   from    './DeleteValidationsModal.vue';
import HistoryModal             from    '@/components/HistoryModal'
import UploadOptions            from    '@/components/UploadOptions'
import UploadSummary            from    '@/components/UploadSummary'
import UnauthorizedComponent    from   '@/components/UnauthorizedComponent'
import HistoryMovementModal     from    './HistoryMovementModal'
import 'vuetify/dist/vuetify.min.css'


import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name:   'RoomType',

    components:{
    Breadcrumb,
    WaitingModal,
    FormModal,
    UpdateModal,
    HistoryModal,
    DinamicTable,
    DeletionMassiveModal,
    UploadOptions,
    UploadSummary,
    UnauthorizedComponent,
    DeleteValidationsModal,
    HistoryMovementModal,
    HelperModal
},

    data(){
        return {
            notyf,
            user:               this.get_user(),
            child_href:          '/building-room-types/',
            axios,
            title_page:         'Room types',
            content_header:     this.$store.state.headers,
            rest_api:           `room_types`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Room type',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            room_types:         [],
            tasks:              [],
            policings:          [],
            array_options:      {},
            select_ids:         [],
            excel_file_headers:      Resources.excel_file_headers,
            excel_file_task_headers: Resources.excel_file_task_headers,
            empty_format_data:      Resources.empty_format_data,
            task_empty_format_data: Resources.task_empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            summary:                [],
            excel_data:             [],
            validate_data:          [],
            failed_file_excel_name: '',
            excel_file_headers_summary: [],
            history_title: '',
            history_item: {},
            helps:                  Resources.helps
        }
    },
    
    methods:{

        format_boolean(value)
        {
            var boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },

        unshift_object(new_object)
        {
            this.room_types.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.room_types.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            this.clean_up(true)
            window.$('#static').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = {...this.room_types[index]}
            this.clean_up(false)
            window.$('#static-update').modal('show')
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }
            
            this.history_item = {
                id,
                title,
            }

            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
            this.loader()

            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories
                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
                this.loader()
            }
            else
            {
                this.error_handling(response)
            }  
        },

        linkEmitReceptor()
        {
            window.$('#static-history').modal('hide')
            this.$refs.history_movement_modal.historialRefresh()

            setTimeout(() => {
                window.$('#static-history-movement').modal('show')
            }, 500)
        },

        linkEmitEmisor()
        {
            window.$('#static-history-movement').modal('hide')

            setTimeout(() => {
                window.$('#static-history').modal('show')
            }, 500)
        },

        emitAction(data)
        {
            if(data.header == 'room_counter_record')
            {
                const id = this.$refs.dinamic_table.display_items[data.index].id || null;
                this.$router.push(`/building-rooms?room_type_id=${id}`)
            }
        },

        clean_up(new_record)
        {
            if(this.tasks.length)
            {
                this.tasks.map((item) =>
                {
                    item.frequency = ''
                    item.order     = ''
                    item.checked = false
                })
            }
            if(this.policings.length)
            {
                this.policings.map((item) =>
                {
                    item.frequency = ''
                    item.order     = ''
                    item.checked = false
                })
            }

            if(!new_record)
            {
                this.single_object.daily_tasks.forEach(daily_task => 
                {
                    const index = this.tasks.findIndex(item => item.id === daily_task.id)

                    if(index > -1)
                    {
                        this.tasks[index] = {...daily_task, checked: true}
                    }
                    else
                    {
                        this.tasks[index].frequency = ''
                        this.tasks[index].order     = ''
                        this.tasks[index].checked   = false
                    }
                    
                });

                this.single_object.policing_tasks.forEach(policing_task => 
                {
                    const index = this.policings.findIndex(item => item.id === policing_task.id)

                    if (index > -1)
                    {
                        this.policings[index] = {...policing_task, checked: true}
                    }
                    else
                    {
                        this.policings[index].frequency = ''
                        this.policings[index].order     = ''
                        this.policings[index].checked   = false
                    }
                    
                });
            }
        },

        fill_data(data)
        {
            this.room_types = data.room_types
            this.array_options = {
                floor_id: data.floors,
                vacant_bed_adjustment_id: data.vacant_bed_adjustments
            }
            this.tasks = data.tasks
            this.policings = data.policings
        },

        trashing(index)
        {
            this.room_types.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.room_types.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let response = await this.massive_delete(json_request, null, true)

            if(response.status)
            {
                if(response.data.validations && response.data.validations.length)
                {
                    window.$('#delete-validations').modal('show')
                    this.validate_data = response.data.validations;
                }

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.room_types.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.room_types.splice(index, 1)
                    }
                })

                this.select_ids = []
            }
            else
            {
                this.error_handling(response)
            }
        },

        async upload(data)
        {
            this.failed_file_excel_name = 'room_types_failed_template_file'
            this.excel_file_headers_summary = this.excel_file_headers
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const floor_type = this.array_options.floor_id.find(item => item.name == entity.floor_id)
                entity.floor_id = floor_type ? floor_type.id : null

                const vacant_bed_adjustment = this.array_options.vacant_bed_adjustment_id.find(item => item.name == entity.vacant_bed_adjustment_id)
                entity.vacant_bed_adjustment_id = vacant_bed_adjustment ? vacant_bed_adjustment.id : null
                
                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { room_types: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const room_type of response.data.room_types)
                {
                    this.unshift_object(room_type);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

        async uploadTasks(data)
        {
            this.failed_file_excel_name = 'room_type_tasks_failed_template_file'
            this.excel_file_headers_summary = this.excel_file_task_headers

            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive_tasks`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers_tasks
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                if(this.hasPermissions(['Building-Room-Type Read', 'Building-Room-Type Write', 'Building-Room-Type Room-Type-Upload']))
                {
                    this.api_request()
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel_tasks.clear_data()
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Room-Type Read', 'Building-Room-Type Write', 'Building-Room-Type Room-Type-Upload']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.room_types.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}

</script>
